import BlockContent from "@sanity/block-content-to-react";
import { client } from "@lib/sanity";
import { serializers } from "./serializers";
import styles from "../styles/RichText.module.css";

const { projectId, dataset } = client.config();

export function RichText({ data }) {
  if (!data.content) {
    console.error("Missing blocks");
    return null;
  }

  const richTextStyles = `
    ${styles.container}
    ${data.isCentered ? styles.center : ""}
  `;

  return (
    <BlockContent
      blocks={data.content}
      serializers={serializers}
      projectId={projectId}
      dataset={dataset}
      renderContainerOnSingleChild={true}
      className={richTextStyles}
    />
  );
}
